import ItemToItem from './ItemToItem'

import { connect } from 'react-redux'
import { actions } from '.'
import { getItemToItemRecomendation } from '../reducer'

const mapStateToProps = ({ products, recomendation }) => ({
  ...getItemToItemRecomendation(products, recomendation)
})

const mapDispatchToProps = dispatch => ({
  fetchItemToItemRecomendation: productId =>
    dispatch(actions.fetchItemToItemRecomendation(productId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemToItem)



// WEBPACK FOOTER //
// ./src/features/Recomendation/ItemToItem/ItemToItemContainer.js